import React from 'react';
import { useTranslation } from 'react-i18next';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { ContentLayout, LayoutGap } from '@gov-nx/ui/web';

export const OwnDocumentFormSkeleton = () => {
	const { t: tg } = useTranslation(LocalizeNameSpaceTypes.Global);
	return (
		<ContentLayout>
			<LayoutGap gap="l">
				<div>
					<GovSkeleton
						width="115px"
						height="22px"
						aria-label={tg('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<div className="[ md:w-[330px] ]">
						<GovSkeleton
							width="100%"
							height="40px"
							aria-label={tg('loading.wcag.processing', {
								namespace: LocalizeNameSpaceTypes.Global,
							})}
						/>
					</div>
				</div>
				<div>
					<GovSkeleton
						width="115px"
						height="22px"
						aria-label={tg('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						width="100%"
						height="190px"
						aria-label={tg('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
				</div>
				{[0, 1, 2].map((i) => (
					<div key={i}>
						<GovSkeleton
							width="115px"
							height="22px"
							aria-label={tg('loading.wcag.processing', {
								namespace: LocalizeNameSpaceTypes.Global,
							})}
						/>
						<div className="[ md:w-[330px] ]">
							<GovSkeleton
								width="100%"
								height="40px"
								aria-label={tg('loading.wcag.processing', {
									namespace: LocalizeNameSpaceTypes.Global,
								})}
							/>
						</div>
					</div>
				))}
				<div>
					<GovSkeleton
						width="115px"
						height="22px"
						aria-label={tg('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						width="100%"
						height="115px"
						aria-label={tg('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
				</div>
				<div className="flex flex-col justify-end gap-4 [ md:flex-row ]">
					<div className="[ md:w-[75px] ]">
						<GovSkeleton
							width="100%"
							height="40px"
							aria-label={tg('loading.wcag.processing', {
								namespace: LocalizeNameSpaceTypes.Global,
							})}
						/>
					</div>
				</div>
			</LayoutGap>
		</ContentLayout>
	);
};
